import { render, staticRenderFns } from "./manage-agent.vue?vue&type=template&id=6b51d9d7&scoped=true&"
import script from "./manage-agent.vue?vue&type=script&lang=js&"
export * from "./manage-agent.vue?vue&type=script&lang=js&"
import style0 from "./manage-agent.vue?vue&type=style&index=0&id=6b51d9d7&prod&scoped=true&lang=css&"
import style1 from "./manage-agent.vue?vue&type=style&index=1&id=6b51d9d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b51d9d7",
  null
  
)

export default component.exports